import {
  Component, Input
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillComponent } from '@sondermind/features/pill';
import { IPill } from '../../models/provider-list.interface';

@Component({
  selector: 'pills',
  standalone: true,
  imports: [CommonModule, PillComponent],
  templateUrl: './pills.component.html',
  styleUrls: ['./pills.component.scss'],
})
export class PillsComponent {
  @Input() pillsData: IPill[];
  @Input() profileLinkUrl: string;
  @Input() matchedProviderSpecialties: string[] = [];
}
